import axios from 'axios';
import { LoginApi, LoginMicrosoftApi } from '@/utils/echoApi';
import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT
} from '../actions/auth';
import store from '@/store';
// import { USER_REQUEST } from '../actions/user'
// import apiCall from '@/utils/api'

// const state = { token: JSON.parse(localStorage.getItem('authUser')) || '', status: '', hasLoadedOnce: false }

// const getters = {
//   isAuthenticated: state => state.token.access_token,
//   authStatus: state => state.status
// }

const actions = {
  // [AUTH_REQUEST]: ({commit, dispatch}, user) => {
  //   return new Promise((resolve, reject) => {
  //     commit(AUTH_REQUEST)
  //     apiCall({url: 'auth', data: user, method: 'POST'})
  //       .then(resp => {
  //         localStorage.setItem('user-token', resp.token)
  //         // Here set the header of your ajax library to the token value.
  //         // example with axios
  //         // axios.defaults.headers.common['Authorization'] = resp.token
  //         commit(AUTH_SUCCESS, resp)
  //         dispatch(USER_REQUEST)
  //         resolve(resp)
  //       })
  //       .catch(err => {
  //         commit(AUTH_ERROR, err)
  //         localStorage.removeItem('user-token')
  //         reject(err)
  //       })
  //   })
  // },
  [AUTH_REQUEST]: ({ commit, rootState }, data) => {
    if (data.token) {
      const authUser = {};
      return new Promise((resolve, reject) => {
        axios
          .post(
            'https://' + rootState.data.hostname + LoginMicrosoftApi,
            {
              access_token: data.token
            }
          )
          .then(function(response) {
            // console.log(response.data.access_token)
            authUser.access_token = response.data.access_token;
            authUser.refresh_token = response.data.refresh_token;
            localStorage.setItem('authUser', btoa(JSON.stringify(authUser)));
            localStorage.setItem('notifications', []);
            commit(AUTH_SUCCESS, response);
            // * we need to account_id  in order to call for company details, so we first are waiting for userRequest Response in order to dispatch getCompanyDetails
            store.dispatch('data/userRequest').then(() => {
              store.dispatch('data/getCompanyDetails');
            });
            store.dispatch('data/getTranslations');
            // store.dispatch('data/getMenus')
            store.dispatch('data/getPages');
            // dispatch(USER_REQUEST)
            resolve(response);
          })
          .catch(function(error) {
            // console.log(error);
            reject(error);
          });
        // console.log({Authorization: 'Basic ' + authKey})
      });
    } else {
      let a = data.username + ':' + data.pass;
      // console.log({username: data.username})
      // console.log({password: data.pass})
      // console.log(data)
      let authKey = btoa(a);
      const authUser = {};
      return new Promise((resolve, reject) => {
        axios
          .post(
            'https://' + rootState.data.hostname + LoginApi,
            {
              // username: this.username,
              // password: this.password
            },
            { headers: { Authorization: 'Basic ' + authKey } }
          )
          .then(function(response) {
            // console.log(response.data.access_token)
            authUser.access_token = response.data.access_token;
            authUser.refresh_token = response.data.refresh_token;
            localStorage.setItem('authUser', btoa(JSON.stringify(authUser)));
            localStorage.setItem('notifications', []);
            commit(AUTH_SUCCESS, response);
            // * we need to account_id  in order to call for company details, so we first are waiting for userRequest Response in order to dispatch getCompanyDetails
            store.dispatch('data/userRequest').then(() => {
              store.dispatch('data/getCompanyDetails');
            });
            store.dispatch('data/getTranslations');
            // store.dispatch('data/getMenus')
            store.dispatch('data/getPages');
            // dispatch(USER_REQUEST)
            resolve(response);
          })
          .catch(function(error) {
            // console.log(error);
            reject(error);
          });
        // console.log({Authorization: 'Basic ' + authKey})
      });
    }
  },
  [AUTH_LOGOUT]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT);
      localStorage.removeItem('authUser');
      localStorage.removeItem('authBUser');
      localStorage.removeItem('weg-portal');
      localStorage.removeItem('currentWarehouse');
      localStorage.removeItem('currentLocation');
      window.location.reload();
      resolve();
    });
  }
};

const mutations = {
  [AUTH_REQUEST]: state => {
    state.status = 'loading';
  },
  [AUTH_SUCCESS]: (state, resp) => {
    // state.status = 'success'
    // state.token = resp.data.access_token
    store.state.data.tokenData = resp.data;
    // state.hasLoadedOnce = true
  },
  [AUTH_ERROR]: state => {
    state.status = 'error';
    // state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: state => {
    store.state.data.tokenData = '';
    store.state.data.UserData = '';
  }
};

export default {
  // state,
  // getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js